import { GQL_ID } from "@@partner:types:graphql";
import { gql, useMutation } from "@apollo/client";

type Response = {
  confirmPayment: {
    ok: boolean
    error?: string
  }
}

type Variables = {
  order_id: GQL_ID
  payment_id: GQL_ID
}

export const GQL_MUTATION_CONFIRM_PAYMENT = gql`
  mutation confirmPayment ($order_id: ID!, $payment_id: ID!) {
    confirmPayment(
      order_id: $order_id
      payment_id: $payment_id
    ) {
      ok
      error
    }
  }
`


export function useConfirmPayment () {
  return useMutation<Response, Variables>(GQL_MUTATION_CONFIRM_PAYMENT)
}